import { imageUtils } from "@/business/shared/commons/imageUtils/imageUtils";

export interface BannerCreateRequest {
  position: string;
  image: File;
}

export interface Banner {
  position: string;
  path: string;
}

export function BannerActions() {
  function createBannerRequest(
    position: string,
    image: File
  ): BannerCreateRequest {
    return {
      position: position,
      image: image,
    };
  }

  function bannerInfo(position: string, path: string): Banner {
    return {
      position: position,
      path: path,
    };
  }

  function deserialize(object: string): Banner[] {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return parseResponse.map((banner: Banner) => {
      return bannerInfo(banner.position, imageUtils.putTimeStamp(banner.path));
    });
  }

  return {
    createBannerRequest,
    bannerInfo,
    deserialize,
  };
}
